import React from 'react';

import { formatAccountNumber } from '@eika-infrastruktur/format';
import { ListPanel } from '@eika/link-panel';

import type { Account } from '../../generated-types';
import {
    accessibileAccountNumber,
    accessibleCurrency,
    createOwnersAriaLabel,
} from '../../services/accessibilityService';
import getBalances from '../../services/getBalanceService';
import { AccountLabels } from '../shared/AccountLabels';

interface Props {
    account: Account;
    detailsLink?: string;
    hideDecimals?: boolean;
}

const AccountListElement: React.FC<Props> = ({ account, detailsLink, hideDecimals = false }) => {
    const { currency, accountNumber, balance, type, accountId, alias, owners } = account;
    const [mainBalance, secondaryBalance] = getBalances(balance, currency, type, hideDecimals);

    return (
        <ListPanel
            data-testid="account-list-item"
            className="account-list__element"
            key={accountId.value}
            labels={<AccountLabels owners={owners} />}
            url={`${detailsLink}?id=${accountId.value}&accountType=${type}`}
            title={alias}
            textOne={mainBalance}
            textTwo={formatAccountNumber(accountNumber)}
            textThree={secondaryBalance}
            ariaLabel={`${createOwnersAriaLabel(owners)} ${alias}, ${accessibleCurrency(
                balance.availableBalance,
                currency,
                0,
            )}, på konto ${accessibileAccountNumber(formatAccountNumber(accountNumber))}`}
            as="li"
        />
    );
};

export default AccountListElement;
